import Vue from "vue";
import { ethers } from "ethers";

/**
 *
 * @param {*} balance BigNumber(in wei)
 * @returns
 */
function ethFormat(value) {
  if (!value) return 0;
  // return Math.round(value) / 100000;
  // return ethers.utils.formatEther(value);
  return ethers.utils.formatUnits(value, "ether");
}

function usdFormat(value) {
  if (!value) return 0;
  return value.toFixed(2) + " USD";
}

function addressFormat(address) {
  if (!address) return "";
  return address.substring(0, 6) + "**" + address.substring(address.length - 4);
}

function networkName(value) {
  switch (value) {
    case "homestead":
      return "Main Ethereum Network";
    case "kovan":
      return "Koven Test Network";
    case "ropsten":
      return "Ropsten Test Network";
    case "rinkeby":
      return "Rinkeby Test Network";
    case "goerli":
      return "Goerli Test Network";
    case "private":
      return "Private Test Network";
    default:
      return value;
  }
}

function gridStatus(value) {
  switch (value) {
    case "normal":
      return "For Sale";
      break;
    case "sold":
      return "Sold";
      break;
    case "pending":
      return "Pending";
      break;
  }
  return value;
}

export default {
  install(Vue) {
    Vue.filter("ethFormat", ethFormat);
    Vue.filter("usdFormat", usdFormat);
    Vue.filter("addressFormat", addressFormat);
    Vue.filter("networkName", networkName);

    Vue.filter("ethPrice", ethFormat);
    Vue.filter("ethAccount", addressFormat);

    Vue.filter("gridStatus", gridStatus);
  }
};
